import axios from "axios";

const instance = axios.create({
    baseURL: "https://raw.githubusercontent.com/rostov114/rust-items/main/",
});

export default instance;
